<template>
  <div class="list-item" @click="itemClicked(shop)" v-if="shop">
    <div
      class="item-image"
      :style="{
        backgroundImage: `url('${shop.site.topImage.imageUri}')`
      }"
    ></div>

    <div class="item-text">
      <div class="title">{{ shop.nameKanji }}</div>
      <div class="text">{{ shop.site.genre.genre }}</div>
      <div v-if="locationDetected" class="distance">
        現在地から {{ shop.distanceFromUser | distance }}
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex"

export default {
  props: ["shop"],

  methods: {
    itemClicked(shop) {
      this.$emit("itemClicked", shop)
    }
  },

  computed: {
    ...mapGetters("map", ["locationDetected"])
  },

  filters: {
    distance(value) {
      if (isNaN(value)) {
        return ""
      }

      if (value < 1) {
        return `${Math.round(value * 1000)} m`
      }

      return `${parseFloat(value).toFixed(1)} km`
    }
  }
}
</script>

<style scoped>
.list-item {
  display: flex;
  width: 100%;
  padding: 16px 20px;
}

.list-item + .list-item::before {
  content: "";
  position: absolute;
  left: 20px;
  top: 0;
  width: calc(100% - 20px);
  height: 1px;
  background: #f0f0f1;
}

.list-item::after {
  content: "";
  position: absolute;
  top: 50%;
  right: 22px;
  width: 44px;
  height: 44px;
  margin-top: -22px;
  background: url("../assets/icon-arrow-right.svg") right center no-repeat;
}

.item-image {
  width: 90px;
  height: 60px;
  border-radius: 6px;
  flex-shrink: 0;
}

.item-text {
  padding-left: 12px;
}

.list-item .item-text .title {
  font-size: 14px;
  line-height: 1.71;
  font-weight: bold;
}

.list-item .item-text .text {
  font-size: 12px;
  color: #9b9ca7;
  line-height: 1.67;
}

.list-item .item-text .distance {
  font-size: 12px;
  line-height: 1.67;
}
</style>
